/* eslint-disable no-underscore-dangle */
import type { GetServerSideProps, GetServerSidePropsContext } from 'next'
import { getSession } from 'next-auth/react'
import {
  MeDocument,
  MeQuery,
  MeQueryVariables,
} from 'generated/apolloComponents'
import { initializeApollo } from '@/api/apollo'

export const isAdmin = (me?: MeQuery['me'] | null): boolean =>
  me?.__typename === 'Admin'

export const fetchMe = async (
  context: GetServerSidePropsContext
): Promise<MeQuery['me']> => {
  const apolloClient = initializeApollo({ ctx: context })
  const { data } = await apolloClient.query<MeQuery, MeQueryVariables>({
    query: MeDocument,
  })

  return data.me
}

export const withAdmin =
  (gssp?: GetServerSideProps): GetServerSideProps =>
  async (context) => {
    const me = await fetchMe(context)
    if (!isAdmin(me)) {
      return { notFound: true }
    }

    if (!gssp) {
      return {
        props: {
          session: await getSession(context),
        },
      }
    }

    return gssp(context)
  }
